// src/utils/exportToPDF.js
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

/**
 * Legacy PDF export used ONLY by analytics dashboards.
 * Flyer printing now uses /api/flyer-pdf.js (Playwright screenshot pipeline).
 */
export async function exportToPDF(elementId, filename = "export.pdf") {
  const element = document.getElementById(elementId);
  if (!element) {
    console.error(`exportToPDF: element #${elementId} not found`);
    return;
  }

  // Capture element
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    backgroundColor: "#ffffff",
  });

  const imgData = canvas.toDataURL("image/png");

  // Create PDF (auto portrait)
  const pdf = new jsPDF({
    orientation: "portrait",
    unit: "px",
    format: "a4",
  });

  const pageWidth = pdf.internal.pageSize.getWidth();
  const pageHeight = pdf.internal.pageSize.getHeight();

  // Fit image inside page
  pdf.addImage(imgData, "PNG", 0, 0, pageWidth, pageHeight);

  pdf.save(filename);
}
